// extracted by mini-css-extract-plugin
export default {"fadeIn":"x9dGzEDzUK_x7LyTB6LH"};